



































































































import { defineComponent, reactive, SetupContext, toRef, toRefs, watch } from "@vue/composition-api";
import * as Common from "../../commons/common"
import http from "../../plugins/http";
import AlertArea from "../../components/AlertArea.vue";
import { User } from "../../modules/teacher/TeacherCreate"

interface UserData {
  currentUser: any;
  user: User;
  errors: string[];
  selectedRole: string;
}

export default defineComponent({
  components: {
    "alert-area": AlertArea,
  },
  setup(props, context: SetupContext) {

    /******************************
     * data
     ******************************/

    const state = reactive<UserData>({
      currentUser: context.root.$store.state.currentUser,
      user: new User(context.root.$store.state.curriculums, []),
      errors: [],
      selectedRole: context.root.$route.query.role?.toString(),
    });


    /******************************
     * methods
     ******************************/
    
    /**
     * 戻る処理
     */
    const goBack = (): void => {
        context.root.$router.go(-1);
    };

    /**
     * ユーザ登録処理
     */
    const userCreate = async (): Promise<void> => {

      if (!validate() || !confirm(`教師情報を登録します。よろしいですか？`)) {
        return;
      }

      state.user.curriculum_id = state.user.curriculums.filter(x => x.is_selected).map(x => x.id).join(",")
      
      context.root.$store.dispatch("showOverlay");

      state.errors = [];

      await http.post(`/api/teacher/entrance_teacher_create`, {user: state.user}).then(response => {
        alert(`登録処理が完了しました。`);
        goBack();
      })
      .catch(error=>{
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = [`予期せぬ例外が発生しました。`];
        }
      });

      context.root.$store.dispatch("hideOverlay");
    }

    /**
     * 入力チェック処理
     */
    const validate = (): boolean => {

        state.errors = [];

        if (state.user.school_id == "") {
          state.errors.push("学校は必須です。");
        }

        if(!state.user.login_id){
          state.errors.push("ログインIDは必須です。");
        }

        if(!state.user.password){
          state.errors.push("パスワードは必須です。");
        }

        if (state.user.role == "") {
            state.errors.push("権限は必須です。選択してください。");
        }

        return state.errors.length == 0;
    }

    const checkDispPageByRole = (): void => {

      if (state.selectedRole == "admin" && state.currentUser.role != "admin") {
        goBack();
      }

      if (state.selectedRole != "admin") {
        state.user.school_id = state.currentUser.school_id;
      }
    }


    /******************************
     * created
     ******************************/

    checkDispPageByRole();


    /******************************
     * watch
     ******************************/


    return {
      ...toRefs(state),
      goBack,
      userCreate,
    };
  },
})
